import React from "react"
import App from "./App"
import fetch from "node-fetch"
import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from "@apollo/client"
import { setContext } from "apollo-link-context"
import Config from "./config/config"
import store from "./store/store";
import { Provider } from 'react-redux';

const httpLink = createHttpLink({
  uri: Config.API_URL, // ENTER URL HERE
  fetch: fetch
})


const authLink = setContext(() => {
  const token = localStorage.getItem("jwtToken")
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
  }
})

//TODO: Think caching (ApolloClient InMemoryVars, or Memcache?)
export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})

export default (
  <Provider store={store} >
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </Provider>
)
